import { createI18n } from 'vue-i18n';

const messages = {
  en: {
    currency: {
      style: 'currency',
      currency: 'USD',
    },
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    day: 'day | days', // Singular | Plural
    hour: 'hour | hours',
    minute: 'minute | minutes',
    second: 'second | seconds',
    adult: 'All',
    adult: 'Adult',
    teenager: 'Teenager',
    child: 'Child',
    infant: 'Infant',
    years: 'year | years', // Plural form
    up_to: 'Up to',
    next: 'Next',
    plus_years: '+ year | + years', // Plural form
  },
  pl: {
    currency: {
      style: 'currency',
      currency: 'PLN',
    },
    weekdays: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'],
    months: ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'],
    day: 'dzień | dni', // Singular | Plural
    hour: 'godzina | godziny | godzin',
    minute: 'minuta | minuty | minut',
    second: 'sekunda | sekundy | sekund',
    adult: 'Dorosły | Dorosłych', // Singular | Plural
    all: 'Uczestnik | Liczba uczestników', // Singular | Plural
    teenager: 'Nastolatek | Nastolatków', // Doesn't change in Polish
    child: 'Dziecko | Dzieci', // Singular | Plural
    infant: 'Niemowlę | Niemowlęta', // Singular | Plural
    years: 'rok | lat | lat', // Polish requires a three-form plural rule
    up_to: 'do',
    close: 'Zamknij',
    next: 'Dalej',
    prev: 'Cofnij',
    plus_years: '+ rok | + lata | + lat', // Singular | Plural (two forms)
  },
};

const numberFormats = {
  en: {
    currency: {
      style: 'currency',
      currency: 'USD',
    },
  },
  pl: {
    currency: {
      style: 'currency',
      currency: 'PLN',
    },
  },
};

const datetimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    medium: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
    },
  },
  pl: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    medium: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    },

    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
    },
  },
};

const i18n = createI18n({
  locale: 'pl', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages, 
  numberFormats, 
  datetimeFormats
});

// Export the translation function for use outside Vue components
export const $t = i18n.global.t;

// en: { weekdays: ['Sunday', ...], months: ['January', ...] }
// pl: { weekdays: ['niedziela', ...], months: ['styczeń', ...] }
//
// Then use $t('weekdays.0') or $t('months.0') in your components.

export default i18n;